<template>
  <div class="cotainer card-item">
    <div class="card-title">
      <div class="title-box">
        <span class="title-text">{{ cardTitle }}</span>
      </div>
      <div class="title-boxs">
        <span class="btn-action-group">
          <a-button
            type="primary"
            v-if="(oldInfos?.id && isRevise) || !isScore"
            @click="addTeachers"
            class="btn-action"
            >新增</a-button
          >
          <!-- <a-button
            class="btn-action"
            type="primary"
            v-if="oldInfos?.id"
            @click="showevidence"
          >
            佐证材料</a-button
          > -->
          <!-- <a-button
            @click="importsj()"
            v-if="(oldInfos?.id && isRevise) || !isScore"
            class="btn-action"
            >导入</a-button
          > -->
          <a-button
            class="btn-action"
            v-if="(oldInfos?.id && isRevise) || !isScore"
            danger
            type="text"
            @click="batchDelete"
          >
            批量移除</a-button
          >
        </span>
      </div>
    </div>

    <div class="cotainerfottter">
      <a-table
        style="text-align: center"
        :locale="{ emptyText }"
        :columns="columns"
        :data-source="dataList"
        :loading="loading"
        @change="handleTableChange"
        :pagination="pagination"
        :bordered="true"
        rowKey="id"
        :scroll="{ x:1280,y: 290 }"
        :row-selection="rowSelection"
      >
        <template slot="sequenceNumber" slot-scope="text, record, index">
          {{ (pagination.current - 1) * pagination.pageSize + index + 1 }}
        </template>
        <template slot="sex" slot-scope="text, record, index">
          {{ text }}
        </template>
        <template slot="izResponse" slot-scope="text, record, index">
          <span v-if="record.izResponse == '1'">是</span>
          <span v-else>否</span>
        </template>

        <span
          class="flex flex-around"
          slot="action"
          slot-scope="record"
          style="margin: 0 30px"
        >
          <div
            class="flex align-items-center"
            style="cursor: pointer"
            v-if="(oldInfos && oldInfos.id && !isEdit) || isScore"
            @click="showevidence(record)"
          >
            <img class="img-box" src="../../assets/images/imgcl.png" alt="" />
            <span>佐证材料</span>
          </div>
          <div
            class="flex align-items-center"
            style="cursor: pointer"
            v-if="(oldInfos && oldInfos.id && isRevise) || !isScore"
            @click="editInfo(record)"
          >
            <img class="img-box" src="../../assets/images/img42.png" alt="" />
            <span>编辑</span>
          </div>
          <div
            class="flex align-items-center"
            style="cursor: pointer"
            v-if="(oldInfos && oldInfos.id && isRevise) || !isScore"
            @click="deleteInfo(record)"
          >
            <img class="img-box" src="../../assets/images/img43.png" alt="" />
            <span>移除</span>
          </div>
          <div
            class="flex align-items-center"
            style="cursor: pointer"
            v-if="(oldInfos && oldInfos.id && !isRevise) || isScore"
            @click="seeInfo(record)"
          >
            <img class="img-box" src="../../assets/images/img42.png" alt="" />
            <span>查看</span>
          </div>
        </span>
      </a-table>
    </div>
    <a-modal
      title="您确定移除吗"
      :visible="showDeleteModel"
      ok-text="确认"
      cancel-text="取消"
      @ok="handleOk"
      @cancel="showDeleteModel = false"
    >
      <p>您确定要移除这位老师的数据吗?</p>
    </a-modal>
    <!-- 添加老师 -->
    <add-teacher ref="addTeacher" @addTeacher="addTeachercz"></add-teacher>
    <data-import ref="dataImport" @refreshData="addTeacher"></data-import>
    <div class="preview-pop-box" v-if="showtable">
      <div class="preview-boxs">
        <evidencelist
          :title="title"
          :isEdit="isEdit"
          :id="id"
          @closePreview="showtable = false"
          :dataid="sj.id"
        >
        </evidencelist>
      </div>
    </div>
  </div>
</template>

<script>
import { getAction, postAction, putAction, deleteAction } from "@/api/index";
import dataImport from "@/components/common/dataImport.vue";
import evidencelist from "@/components/common/evidencelist";
const columns = [
  {
    title: "序号",
    dataIndex: "sequenceNumber",
    id: "sequenceNumber",
    align: "center",
    scopedSlots: { customRender: "sequenceNumber" },
    width: 70,
  },
  {
    title: "教师姓名",
    dataIndex: "teacherName",
    id: "teacherName",
    align: "center",
    width: 100,
  },
  {
    title: "性别",
    dataIndex: "sex",
    id: "sex",
    align: "center",
    width: 70,
    scopedSlots: { customRender: "sex" },
  },
  // {
  // 	title: "生日",
  // 	dataIndex: "birthday",
  // 	id: "birthday",
  // 	align: "center",
  // 	width: 100,
  // },
  {
    title: "学历",
    dataIndex: "education",
    id: "education",
    align: "center",
    width: 100,
  },
  {
    title: "职称",
    dataIndex: "professionalTitle",
    id: "professionalTitle",
    align: "center",
    width: 100,
  },
  // {
  //   title: "从事内容",
  //   dataIndex: "engagedContent",
  //   id: "engagedContent",
  //   align: "center",
  // },
  // {
  // title: "是否思政教师",
  // dataIndex: "izPolitical_dictText",
  // id: "izPolitical_dictText",
  // align: "center",
  // width: 130,
  // },
  {
    title: "是否负责人",
    dataIndex: "izResponse",
    id: "izResponse",
    align: "center",
    //scopedSlots: { customRender: "izResponse" },
    width: 130,
  },
  {
    title: "加入年份",
    dataIndex: "joinYear",
    id: "joinYear",
    align: "center",
    width: 100,
  },
  // {
  // title: "成员来源",
  // dataIndex: "memberSource_dictText",
  // id: "memberSource_dictText",
  // align: "center",
  // width: 100,
  // },

  {
    title: "操作",
    id: "action",
    align: "center",
    width: 234,
    fixed: "right",
    scopedSlots: { customRender: "action" },
  },
];
import addTeacher from "./addTeamTeach.vue";
export default {
  data() {
    return {
      dataList: [],
      loading: false,
      showDeleteModel: false,
      deteleId: "",
      pagination: {
        total: 0,
        current: 1,
        pageSize: 5,
      },
      columns: columns,
      selectedRowKeys: [],
      isEdit: false,
      showtable: false,
      id: "",
      title: "",
      // isbjs:true,
      emptyText: "暂无数据",
      sj: {},
      isScore: false,
    };
  },
  watch: {
    "oldInfos.brandlist": {
      handler(newValue, oldValue) {
        // console.log(newValue, "9999999999999999");
        if (newValue != null) {
          // this.oldInfos = newValue;
          // console.log(this.oldInfos.type);
          if (
            this.$parent.editInfo &&
            this.$parent.editInfo?.type == "preview"
          ) {
            this.isEdit = true;
          } else {
            this.isEdit = false;
          }
          // console.log(this.$parent.baseInfo?.isbjs,"ssss");
          // if(this.$parent.baseInfo && this.$parent.baseInfo?.isbjs){
          //   this.isbjs =false;
          // }
          this.emptyText = "暂无数据";
          this.addTeacher();
        }
        // console.log(newValue, "8989898989");
      },
      deep: true,
    },
    "oldInfos.isbjs": {
      handler(newValue, oldValue) {
        // console.log(newValue,'我是')
      },
      deep: true,
    },
    isRevise: {
      handler(newValue, oldValue) {
        console.log(newValue, "我是");
        this.isEdit = !newValue;
      },
      immediate: true,
    },
  },

  props: {
    oldInfos: {
      type: Object,
    },
    cardTitle: {
      type: String,
    },
    isbj: {
      type: Boolean,
      defalt: true,
    },
    isRevise: {
      type: Boolean,
    },
  },
  components: {
    addTeacher,
    dataImport,
    evidencelist,
  },
  computed: {
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
        // 其他 row-selection 的配置
      };
    },
  },
  mounted() {
    this.isScore =
      this.$store.state.role === "score-role" ||
      this.$store.state.role === "education-role" ||
      this.$store.state.role === "education-guide-role";
    if (!this.oldInfos?.id) {
      this.emptyText = "填写基本信息之后才能添加内容";
    }
    // this.isEdit =
    //   this.$parent.editInfo && this.$parent.editInfo?.type == "preview";
    // console.log(this.$parent.editInfo,"222222");
    if (this.$parent.editInfo && this.$parent.editInfo?.type == "preview") {
      this.isEdit = true;
    }
    // console.log(this.isEdit,this.$parent.editInfo?.type,"1111");
    //this.getData();
    this.addTeacher();
  },
  methods: {
    showevidence(record) {
      this.title = "品牌团队";
      this.id = this.oldInfos.id;
      this.sj = record;
      this.showtable = true;
    },
    seeInfo(row) {
      this.$refs.addTeacher.init("see", row);
    },
    importsj() {
      this.$refs.dataImport.init("group", this.oldInfos, "工作室团队成员");
    },
    handleOk() {
      this.$message.success("移除成功");
      this.showDeleteModel = false;
      this.oldInfos.brandlist = this.oldInfos.brandlist.filter(
        (item) => item.id != this.deteleId
      );
      sessionStorage.setItem("pp1", JSON.stringify(this.oldInfos));
      this.getData();
      // deleteAction("/lxBase/lxApplyGroup/delete", {
      //   id: this.deteleId,
      //   applyId: this.oldInfos?.id,
      // }).then((res) => {
      //   if (res.code == 200) {
      //     this.$message.success("移除成功");
      //     this.showDeleteModel = false;
      //     this.getData();
      //   } else {
      //     this.$message.error(res.message);
      //   }
      // });
    },
    addTeachercz(sj) {
      console.log("🚀 ~ addTeachercz ~ sj:", sj);

      // console.log(sj);
      if (sj.type == "add") {
        this.pagination.current = 1;
        sj.record.id = sj.record.name + this.oldInfos.brandlist.length;
        this.oldInfos.brandlist.unshift({
          ...sj.record,
          id: sj.record.name + (this.oldInfos.brandlist.length + 1),
        });
      } else {
        let index = this.oldInfos.brandlist.findIndex(
          (item) => item.id === sj.record.id
        );
        console.log(sj.record.id, this.oldInfos.brandlist);
        console.log(index, "index");
        if (index !== -1) {
          // 如果找到相同的 id，替换该对象
          //this.oldInfos.brandlist[index] = sj.record;
          this.$set(this.oldInfos.brandlist, index, sj.record);
        }
        console.log(
          this.oldInfos.brandlist[index],
          "this.oldInfos.brandlist[index]"
        );
      }
      sessionStorage.setItem("pp1", JSON.stringify(this.oldInfos));
      this.getData();
    },
    addTeachers() {
      // console.log("addTeachers this.oldInfos", this.oldInfos);
      this.$refs.addTeacher.init("add", this.oldInfos);
    },
    addTeacher() {
      // this.pagination.current = 1;
      this.getData();
    },
    getData() {
      if (this.oldInfos?.id) {
        this.loading = true;
        let data = {
          applyType: 1,
          pageNo: this.pagination.current,
          pageSize: this.pagination.pageSize,
          applyId: this.oldInfos?.id,
        };
        getAction("/lxBase/lxApplyGroup/list", data).then((res) => {
          if (res.code === 200) {
            let data = res.result.records;
            if (data) {
              this.dataList = data;
              this.pagination.total = res.result.total;
            }
          }
          this.loading = false;
        });
      } else {
        console.log(this.oldInfos, "this.oldInfos");
        if (
          this.oldInfos &&
          this.oldInfos.brandlist &&
          this.oldInfos.brandlist.length > 0
        ) {
          this.pagination.total = this.oldInfos.brandlist.length;
          const startIndex =
            (this.pagination.current - 1) * this.pagination.pageSize;
          const endIndex = startIndex + this.pagination.pageSize;
          // this.dataList = this.oldInfos.brandlist.slice(startIndex, endIndex);
          let formatList = this.oldInfos.brandlist.slice(startIndex, endIndex);
          if (formatList.length == 0 && this.pagination.current > 1) {
            this.pagination.current = this.pagination.current - 1;
            const startIndex =
              (this.pagination.current - 1) * this.pagination.pageSize;
            const endIndex = startIndex + this.pagination.pageSize;
            formatList = this.oldInfos.brandlist.slice(startIndex, endIndex);
          }
          this.dataList = formatList;
        } else {
          this.dataList = [];
          this.pagination.total = 0;
          this.pagination.current = 1;
        }
      }
    },
    deleteInfo(row) {
      this.showDeleteModel = true;
      this.deteleId = row.id;
    },
    editInfo(row) {
      console.log("🚀 ~ editInfo ~ row:", row);
      this.$refs.addTeacher.init("edit", row);
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.getData();
    },
    option(type) {
      if (type === 1) {
        this.$emit("upStep", this.dataList);
      } else {
        this.$emit("downStep", this.dataList);
      }
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    batchDelete() {
      let applyType = 1;
      if (this.$route.name === "szStudio") {
        applyType = 1;
      } else if (this.$route.name === "educationalBrand") {
        applyType = 2;
      } else {
        applyType = 3;
      }
      if (this.selectedRowKeys.length == "0") {
        this.$message.warning("请选择要批量移除的教师");
      } else {
        //this.pagination.current = 1;
        this.oldInfos.brandlist = this.oldInfos.brandlist.filter(
          (item) => !this.selectedRowKeys.includes(item.id)
        );
        sessionStorage.setItem("gzs1", JSON.stringify(this.oldInfos));
        this.getData();
        this.selectedRowKeys = [];
        // let params = {
        //   ids: this.selectedRowKeys.toString(),
        //   applyId: this.oldInfos?.id,
        // };
        // deleteAction("/lxBase/lxApplyGroup/deleteBatch", params).then((res) => {
        //   if (res.code == 200) {
        //     this.$message.success("批量移除成功");
        //     this.pagination.current = 1;
        //     this.getData();
        //     this.selectedRowKeys = [];
        //     this.$forceUpdate();
        //   } else {
        //     this.$message.error(res.message);
        //   }
        // });
      }
    },
  },
};
</script>

<style scoped="scoped" lang="scss">
.cotainer {
  .title-boxs {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    // margin-bottom: 12px;
    font-size: 20px;
  }
  .btn-action {
    width: 100px;
    height: 30px;
    border-radius: 6px;
    font-weight: 400;
    cursor: pointer;
    line-height: 30px;
    margin-right: 10px;
    text-align: center;
  }
  .img-box {
    width: 18px;
    height: 18px;
    margin-right: 9px;
  }
  .img-box-preview {
    width: 21px;
    height: 21px;
    margin-right: 9px;
  }
}
.preview-pop-box {
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  .preview-box {
    margin: 50px auto;
    width: 1177px;
    height: 90%;
  }
  .preview-boxs {
    margin: 50px auto;
    width: 950px;
    height: 700px;
    overflow: hidden;
  }
  .preview-box-fullscreen {
    width: 100vw;
    height: 100vh;
  }
}
</style>
